export const kingaIwanska = {
    'mydrId': 'kingaiwańska',
    'firstName': 'Kinga',
    'lastName': 'Iwańska',
    'profession': 'Psychoterapeuta dzieci i młodzieży w trakcie szkolenia, terapeuta schematu osób dorosłych (w trakcie certyfikacji)',
    'avatar': 'kinga-iwanska.webp',
    'slug': 'psycholog-psychoterapeuta-kinga-iwanska',
    'locations': ['bydgoszcz'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychology', 'consultation']
    ]
}